import DisableUserModal from './DisableUserModal'

export default DisableUserModal;
